/* import __COLOCATED_TEMPLATE__ from './query-selector-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();